import React, { useState } from 'react';
import './MyPortfolioCapsulesSettings.scss';
import { Dropdown } from '@instinet-analytics/semantic-ui-components';
import { WidgetType } from 'widgets/WidgetType';
import { MyPortfolioCapsuleSettings } from 'widgets/myPortfolioCapsules/components/toolbar/MyPortfolioCapsuleSettings';
import { isMyPortfolioCapsuleWidgetStrategyWithConfig } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { MyPortfolioCapsulesWidgetConfigState } from 'widgets/myPortfolioCapsules/store/config/MyPortfolioCapsulesWidgetConfigState';
import { useMyPortfolioCapsuleWidgetStrategies } from 'widgets/myPortfolioCapsules/hooks/useMyPortfolioCapsuleWidgetStrategies';
import { AnyConfig, isWidgetStrategyWithConfig } from 'widgets/WidgetRegistry';
import orderBy from 'lodash/orderBy';

export interface MyPortfolioCapsulesCapsuleSettingsProps {
    config: MyPortfolioCapsulesWidgetConfigState;
    debouncedApplyWidgetConfigChange: (
        delta: Partial<MyPortfolioCapsulesWidgetConfigState>
    ) => void;
}

export default function MyPortfolioCapsulesCapsuleSettings(
    props: MyPortfolioCapsulesCapsuleSettingsProps
) {
    const { config, debouncedApplyWidgetConfigChange } = props;
    const { capsuleType: configCapsuleType } = config;

    const [capsuleType, setCapsuleType] = useState(configCapsuleType);

    const capsuleStrategies = useMyPortfolioCapsuleWidgetStrategies();

    const capsuleDropdownOptions = orderBy(
        capsuleStrategies.map((s) => ({
            text: s.strategy.title,
            value: s.type,
        })),
        ['text']
    );

    const findCapsuleStrategy = (t?: WidgetType) =>
        capsuleStrategies.find((s) => s.type === t)?.strategy;

    const capsuleStrategy = findCapsuleStrategy(capsuleType);

    const onCapsuleTypeChange = (next: WidgetType) => {
        setCapsuleType(next);
        const nextCapsuleStrategy = findCapsuleStrategy(next)!;
        const defaultCapsuleConfig: AnyConfig =
            isWidgetStrategyWithConfig<AnyConfig>(nextCapsuleStrategy)
                ? nextCapsuleStrategy.initialConfigState
                : {};

        debouncedApplyWidgetConfigChange({
            capsuleType: next,
            ...defaultCapsuleConfig,
        });
    };

    return (
        <div>
            <div>Capsule Type</div>
            <div className="capsule-type-editor">
                <Dropdown
                    className="capsule-type-dropdown"
                    options={capsuleDropdownOptions}
                    value={capsuleType}
                    onChange={onCapsuleTypeChange}
                />
            </div>
            {isMyPortfolioCapsuleWidgetStrategyWithConfig<unknown>(
                capsuleStrategy
            ) && (
                <MyPortfolioCapsuleSettings<unknown>
                    strategy={capsuleStrategy}
                    config={config}
                    dispatchConfigChanged={debouncedApplyWidgetConfigChange}
                />
            )}
        </div>
    );
}
